import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import handleViewport from 'react-in-viewport';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'



const AnimationSection = ({ title, description, video, direction, inViewport, forwardedRef }) => {

  const videoPlayer = React.useRef(null);

  React.useEffect(() => {
    if (inViewport ) {
      videoPlayer.current.currentTime = 0;
      videoPlayer.current.play();
    } else {
      videoPlayer.current.pause();
    }
  });

  return (
    <section className="section container" ref={forwardedRef} >
      <div className="columns">
        <div
          className="column px-6"
          style={{ order: direction === 'ltr' ? '1' : '2' }}>
          <video ref={ videoPlayer } muted="muted" playsinline="playsinline" autoPlay="autoPlay" loop >
            <source src={ video } type="video/mp4" />
          </video>
        </div>
        <div
          className="column  px-6"
          style={{
            order: direction === 'ltr' ? '2' : '1',
            alignSelf: 'center'
          }}>
          <h3 className="title has-text-weight-light" dangerouslySetInnerHTML={{__html: title}} ></h3>
          <p>{ description }</p>
          <a className="inpwrd-arrow-link mt-5">
            <FontAwesomeIcon
              icon={faArrowRight}
              className="inpwrd-arrow-link--icon"
              fixedWidth size="lg"
            />
            Start Free Trial
          </a>
        </div>
      </div>
    </section>
  )
}

AnimationSection.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array
  ]),
  description: PropTypes.string,
  video: PropTypes.string,
  direction: PropTypes.string,
}

export default handleViewport(AnimationSection, {
  threshold: 0.8
});
